import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "./app/store"; // Adjust the path if necessary
import Router from "./Router";
import { Toaster } from "react-hot-toast";

const App: React.FC = () => {
  const theme = useSelector((state: RootState) => state.theme.theme);

  useEffect(() => {
    document.documentElement.className = theme; // Set the theme on the <html> element
  }, [theme]);

  return (
    <div className={`flex h-screen bg-lightBg dark:bg-gradient-dark transition-all duration-300 ease-soft-spring`}>
      <Toaster />
      <Router />
    </div>
  );
};

export default App;
